import { render, staticRenderFns } from "./BotSummarizeMini.vue?vue&type=template&id=402240b5&scoped=true"
import script from "./BotSummarizeMini.vue?vue&type=script&lang=js"
export * from "./BotSummarizeMini.vue?vue&type=script&lang=js"
import style0 from "./BotSummarizeMini.vue?vue&type=style&index=0&id=402240b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402240b5",
  null
  
)

export default component.exports